/* 订单跟踪 */
<template>
  <div class="orderTracking">
    <Modal v-model="model" footer-hide :width="800" @on-cancel="cancel">
      <div slot="header" class="orderTracking-header">
        订单跟踪
      </div>
      <div class="orderTracking-main">
        <Logs :logs="lists"></Logs>
      </div>
    </Modal>
  </div>
</template>
<script>
import Logs from "../../views/orders/common/logs";
export default {
  data() {
    return {
      model: false,
      lists: []
    };
  },
  components: {
    Logs
  },
  props: {},
  methods: {
    open(lists) {
      this.model = true;
      this.lists = lists;
    },
    cancel() {
      this.model = false;
    }
  }
};
</script>

<style lang="scss">
.orderTracking-header {
  padding: 20px;
  font-size: 18px;
  padding-top: 0px;
  border-bottom: 1px solid #e7e7e7;
  text-align: left;
}
.orderTracking-main {
  margin-top: -20px;
}
</style>
